module.exports = __webpack_public_path__ + "1a81b097a98214fa20f4fdbaa3e97a41.jpg";